function BalearicIslands({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_599)">
  <path d="M16.0001 0C24.8366 0 32.0001 7.16348 32.0001 16C32.0001 24.8364 24.8366 31.9999 16.0001 31.9999C7.16361 31.9999 0.00012207 24.8364 0.00012207 16" fill="#FFDA44"/>
  <path d="M15.6522 7.11122H29.3049C28.4059 5.76829 27.3089 4.56954 26.0558 3.55566H15.6522V7.11122Z" fill="#D80027"/>
  <path d="M15.6522 14.2225H31.9013C31.7649 12.9896 31.4886 11.7992 31.0884 10.667H15.6522V14.2225Z" fill="#D80027"/>
  <path d="M0.91175 21.333H31.0883C31.4884 20.2008 31.7648 19.0102 31.9012 17.7773H0.098877C0.235127 19.0103 0.511501 20.2008 0.91175 21.333Z" fill="#D80027"/>
  <path d="M5.94425 28.4443H26.0557C27.3088 27.4304 28.4059 26.2316 29.3049 24.8887H2.69519C3.59419 26.2316 4.69119 27.4304 5.94425 28.4443Z" fill="#D80027"/>
  <path d="M16 0C7.16349 0 -6.24995e-05 7.16348 4.08967e-10 16.0001C3.65162 16 7.16349 16.0001 16 16.0001L16 0Z" fill="#4A1F63"/>
  <path d="M13.2174 8.34834V9.73965H12.5218V8.34834H11.1305V9.73965H10.4349V6.95703H7.65227V9.73965H6.95658V8.34834H5.56533V9.73965H4.86964V8.34834H3.47827V12.5222H14.6088V8.34834H13.2174Z" fill="#F0F0F0"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default BalearicIslands;
